export default (editor) => {
    editor.StyleManager.addProperty('general', {
        name: 'Overflow X',
        property: 'overflow-x',
        type: 'select',
        options: [
            { id: 'visible', label: 'visible' },
            { id: 'hidden', label: 'hidden' },
            { id: 'clip', label: 'clip' },
            { id: 'scroll', label: 'scroll' },
            { id: 'auto', label: 'auto' },
        ],
        default: 'visible',
    });
    editor.StyleManager.addProperty('general', {
        name: 'Overflow Y',
        property: 'overflow-y',
        type: 'select',
        options: [
            { id: 'visible', label: 'visible' },
            { id: 'hidden', label: 'hidden' },
            { id: 'clip', label: 'clip' },
            { id: 'scroll', label: 'scroll' },
            { id: 'auto', label: 'auto' },
        ],
        default: 'visible',
    });
    editor.StyleManager.addProperty('general', {
        name: 'Z Index',
        property: 'z-index',
        type: 'integer',
        placeholder: 'auto',
    });
    editor.StyleManager.addProperty('typography', {
        name: 'Hyphens',
        property: 'hyphens',
        type: 'select',
        options: [
            { id: 'none', label: 'none' },
            { id: 'auto', label: 'auto' },
        ],
        default: 'none',
    });
};
